import { config } from "config";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KioskState, SetKioskUsersPayload, SetKioskDevicesPayload } from ".";

const default_page_size = config.PAGE_SIZE;

const initialState: KioskState = {
  kiosks: [],
  kioskUsers: [],
  kioskDevices: [],
  count: 0,
  loading: false,
  refresh: 0,
  refreshLoader: false,
  filters: { page: 1, page_size: default_page_size },
};

export const kioskSlice = createSlice({
  name: "kiosk",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    refresh: (state) => {
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetPage: (state) => {
      state.filters.page = 1;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.refresh += 1;
      state.refreshLoader = true;
      state.filters.page = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refreshLoader = true;
    },
    setKioskUsers: (state, action: PayloadAction<SetKioskUsersPayload>) => {
      const { kioskUsers, count } = action.payload;
      state.kioskUsers = kioskUsers;
      state.count = count;
      state.refreshLoader = false;
    },
    setKioskDevices: (state, action: PayloadAction<SetKioskDevicesPayload>) => {
      const { kioskDevices } = action.payload;
      state.kioskDevices = kioskDevices;
    },
  },
});

const kioskReducer = kioskSlice.reducer;
export const kioskActions = kioskSlice.actions;
export default kioskReducer;


